module.exports = "/_next/static/images/teacher-4-e14ad297a927cd57c6ebdefb6d1c14ec.png";